const TikTokIcon = () => (
    <img
      className="img--footer_social_icon"
      src={`/svg/tiktok.svg`}
      alt="tiktok"
    />
  );
  
  export default TikTokIcon;
  